
export default (API) => ({
    rankPoint(params) {
        return API({
            url: `/saas/v1/ydy/rankPoint`,
            method: 'get',
            params
        });
    }
});